import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Uploadfile from '@/views/common/uploadfile/uploadfile.vue';
import Uploadpic from '@/views/common/uploadpic/uploadpic.vue';
export default {
  name: 'one2onechoice',
  components: {
    Uploadpic: Uploadpic,
    Uploadfile: Uploadfile
  },
  props: {
    questionInfo: Object,
    paperQuestion: Object,
    isEdit: Boolean,
    isShow: Boolean
  },
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      picFileList: [],
      audioFileList: [],
      form: {
        id: '',
        questionId: '',
        questionTypeId: '',
        title: '',
        content: '',
        pic: '',
        audio: '',
        question: '',
        choiceItem: [''],
        choiceItemIndex: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
        correctAnswer: [''],
        score: 0,
        orderIndex: 1
      },
      isValid: false,
      rules: {
        title: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }],
        question: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }],
        correctAnswer: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          validator: this.validateCorrectAnswerItem,
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    isShow: function isShow(val) {
      this.dialogVisible = val;
    }
  },
  methods: {
    dialogOpen: function dialogOpen() {
      console.log(this.questionInfo);
      this.form.orderIndex = this.paperQuestion.orderIndex;
      this.form.correctAnswer = this.questionInfo.correctAnswer;
      this.form.title = this.questionInfo.title;
      this.form.content = this.questionInfo.content;
      this.form.pic = this.questionInfo.pic;
      this.form.audio = this.questionInfo.audio;
      this.form.question = this.questionInfo.question;
      this.form.choiceItem = this.questionInfo.choiceItem;
      this.form.score = this.paperQuestion.score;
      this.form.orderIndex = this.paperQuestion.orderIndex;
      this.form.id = this.questionInfo.id;

      if (this.form.pic.length > 10) {
        this.picFileList = [{
          name: '图片1',
          url: this.form.pic
        }];
      } else {
        this.picFileList = [];
      }

      if (this.form.audio.length > 10) {
        this.audioFileList = [{
          name: '音频1',
          url: this.form.audio
        }];
      } else {
        this.audioFileList = [];
      }

      console.log(this.form);
    },
    close: function close() {
      this.dialogVisible = false;
      this.$emit('submit');
    },
    newChoiceItem: function newChoiceItem() {
      this.form.choiceItem.push('');
    },
    removeChoiceItem: function removeChoiceItem(index) {
      if (this.form.choiceItem.length === 1) return;
      this.form.choiceItem.splice(index, 1);
    },
    newCorrectAnswerItem: function newCorrectAnswerItem() {
      this.form.correctAnswer.push('');
    },
    removeCorrectAnswerItem: function removeCorrectAnswerItem() {
      if (this.form.correctAnswerlength === 1) return;
      this.form.correctAnswer.splice(this.form.correctAnswer.length - 1, 1);
    },
    validateCorrectAnswerItem: function validateCorrectAnswerItem(rule, value, callback) {
      value.forEach(function (e) {
        if (!e) {
          return callback(new Error('请输入答题选项'));
        }
      });

      if (this.form.correctAnswer === '') {
        return callback(new Error('请选择正确答案'));
      }

      return callback();
    },
    save: function save() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.$refs.form.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this.isValid = valid;

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
                if (_this.isValid) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return _this.$nextTick(function () {
                  _this.form.audio = _this.$refs.audioUpload.fileList.length === 0 ? '' : _this.$refs.audioUpload.fileList[0].url;
                  _this.form.pic = _this.$refs.picUpload.fileList.length === 0 ? '' : _this.$refs.picUpload.fileList[0].url;
                });

              case 6:
                params = {
                  id: _this.paperQuestion.id,
                  categoryId: _this.paperQuestion.categoryId,
                  gradeId: _this.paperQuestion.gradeId,
                  unitId: _this.paperQuestion.unitId,
                  paperTypeId: _this.paperQuestion.paperTypeId,
                  paperId: _this.paperQuestion.paperId,
                  questionId: _this.questionInfo.id,
                  question: _this.form.question,
                  title: _this.form.title,
                  content: _this.form.content,
                  pic: _this.form.pic,
                  audio: _this.form.audio,
                  choiceItem: _this.form.choiceItem.map(function (item) {
                    return item.trim();
                  }),
                  correctAnswer: _this.form.correctAnswer,
                  score: _this.form.score,
                  orderIndex: _this.form.orderIndex,
                  questionTypeId: 2
                };

                _this.$api.savePapaerQuestion(params).then(function (res) {
                  _this.paperQuestion.id = res.id;
                  _this.questionInfo.id = res.questionId;

                  _this.$message({
                    message: '保存成功',
                    type: 'success'
                  });
                }).catch(function (e) {
                  _this.$message({
                    message: '保存失败',
                    type: 'error'
                  });
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};